"use client"
import { Container, ContentWrapper, CTAButton, CTAContainer, Headline, Subheadline } from "@/components/ui"
import GradientContainer from "@/components/ui/GradientContainer"
import MediaContainer from "@/components/ui/MediaContainer"
import { useCTAUrl } from "@/lib/use-cta-url"
import { GradientVariant, HeadlineVariant } from '@/types/ui'

import { cn } from "@/lib/utils"
import { usePageSettings } from "@/components/contexts/PageSettingsContext"

interface AIChatFeatureProps {
  className?: string
  gradientVariant?: GradientVariant
  headlineVariant?: HeadlineVariant
  title?: string
  subtitle?: string
}

const AIChatFeature = ({ 
  className="", 
  gradientVariant = '12', 
  headlineVariant,
  title = "Your AI Project Analyst & Advisor",
  subtitle = "Skip research. Get expert-level project insights instantly"
}: AIChatFeatureProps) => {
  const { enableAiChatFeatureGoogleLogin, showGoogleLogoAiChatFeature } = usePageSettings()
  const {href: ctaUrl, isCalendly} = useCTAUrl()
  return (
        <Container variant="section" className={cn("", className)}>
        <ContentWrapper gap="lg">
          <Headline variant={headlineVariant}>{title}</Headline>
          <Subheadline htmlContent={true}>
            {subtitle}
          </Subheadline>
          
          <GradientContainer gradientVariant={gradientVariant} variant="fullscreen">
            <MediaContainer 
              src="https://duv2gcpdgd578.cloudfront.net/tasks/attachments/1758110930265Screenshot%20from%202025-09-17%2017-08-40.png" 
              type="image"
              alt="Dictation Functions"
              className='md:max-w-[75%]'
            />
          </GradientContainer>
           
          {/* CTA Button */}
          <CTAContainer marginTop="sm">
            <CTAButton
              href={ctaUrl}
              variant="primary"
              size="lg"
              enableGoogleLogin={enableAiChatFeatureGoogleLogin && !isCalendly}
              showGoogleLogo={showGoogleLogoAiChatFeature}
              external={ctaUrl.startsWith('http')}
            >
              Get Started
            </CTAButton>
          </CTAContainer>
        </ContentWrapper>
      </Container>
    )
}

export default AIChatFeature